export default {
  main: {
    hero: `
        Nossos jogos<br/>
        são mundos <strong>vibrantes</strong><br/>
        com personagens<br/>
        <strong>encantadores</strong>
      `,
    homescapes: `Uma edição épica da série Scapes™, na qual os jogadores podem renovar uma bela mansão com o mordomo Austin`,
    township: `Um jogo divertido de construção de cidades repleto de eventos, competições e torneios entre jogadores`,
  },
  common: {
    login: 'Entrar',
    logout: 'Sair',
    support: 'Suporte',
    privacy: 'Política de Privacidade',
    terms: `Termos de Serviço`,
    and: 'e',
    guest: 'Visitante',
    play: 'Jogar',
    install: 'Instalar',
  },
  support: {
    title: `Precisa de ajuda?`,
    description: `Se você joga este jogo e está enfrentando alguma dificuldade,
      teremos o maior prazer em ajudar e responder a todas as suas perguntas`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption:
      'Ajude o mordomo Austin a transformar uma mansão maravilhosa em um lar acolhedor e confortável.',
    description: `Ajude o mordomo Austin a transformar uma mansão maravilhosa
      em um lar acolhedor e confortável. Pode entrar, você encontrará
      aventuras a partir do momento em que passar pela porta!`,
    xsolla: 'Xsolla é um distribuidor global autorizado de Homescapes',
    install: {
      title: '@:common.install',
      text: `Homescapes no seu computador!
      Instale a versão web do jogo e visite o Austin com apenas alguns cliques!`,
      button: '@:common.install',
    },
  },
  township: {
    title: 'Township',
    caption: `Construa a cidade dos seus sonhos!
      Colha seus cultivos, processe-os nas fábricas
      e venda as mercadorias para desenvolver a cidade.`,
    description: `Construa a cidade dos seus sonhos!
      Colha seus cultivos, processe-os nas fábricas
      e venda as mercadorias para desenvolver a cidade.`,
    xsolla: 'Xsolla é um distribuidor global autorizado de Township',
    install: {
      title: '@:common.install',
      text: `Township no seu desktop!
      Instale a versão web do jogo e visite sua cidade com apenas alguns cliques!`,
      button: '@:common.install',
    },
  },
  cookie: {
    message: 'Usamos cookies para garantir que você tenha a melhor experiência no nosso site',
    link: `Mais informações`,
    button: 'Aceitar',
  },
  game: {
    notSupported: `Incompatível com dispositivos móveis.
      Entre do seu computador para jogar.`,
  },
};
